import { render, staticRenderFns } from "./workdetail.vue?vue&type=template&id=77112d2e&scoped=true&"
import script from "./workdetail.vue?vue&type=script&lang=js&"
export * from "./workdetail.vue?vue&type=script&lang=js&"
import style0 from "./workdetail.vue?vue&type=style&index=0&id=77112d2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77112d2e",
  null
  
)

export default component.exports